import React, { useEffect, useState } from "react";
import CustomTabs from "../../../components/Tabs/CustomTabs";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import { CustomerColumns } from "../../../assets/Columns/CustomerColumns";
import { SupplierColumns } from "../../../assets/Columns/SupplierColumns";
import SearchableTable from "../../../components/Tables/SearchableTable";
import AddPaymentModal from "../../../components/Modals/AddPaymentModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../../store/Slices/CustomerSlice";
import { fetchSuppliers } from "../../../store/Slices/SupplierSlice";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";

const Payment = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [SearchText, setSearchText] = useState("");
  const [OpenModal, setOpenModal] = useState(false);

  const dispatch = useDispatch();
  const Customers = useSelector((state) => state.Customers);
  const Suppliers = useSelector((state) => state.Suppliers);

  useEffect(() => {
    dispatch(fetchCustomers());
    dispatch(fetchSuppliers());
  }, [dispatch]);

  return (
    <div className="w-full flex flex-col pb-8 gap-y-4">
      <div className="flex justify-end items-center">
        <CustomBtn
          title={"Add Payment"}
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </div>
      <div className="z-10 mb-0">
        <CustomTabs
          tabs={[{ label: "Customer" }, { label: "Company" }]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
      <div className="z-20">
        <div className="w-full mt-5 flex justify-center items-center">
          {Customers.loading ? (
            <div className="flex flex-1 justify-center items-center">
              <FetchingLoading />
            </div>
          ) : (
            Customers.data &&
            activeTab === 0 && (
              <SearchableTable
                //   setOpenEditModal={setOpenEditModal}
                //   setOpenDeleteModal={setOpenDeleteModal}
                //   setSelected={setSelected}
                SearchPlaceholder={"Search Customer Name..."}
                SearchText={SearchText}
                setSearchText={setSearchText}
                // CurrentData={Customers.data}
                CurrentData={Customers.data}
                Columns={[
                  {
                    id: "payments",
                    title: "Payments",
                    type: "Customer",
                  },
                  ...CustomerColumns.filter(
                    (dt) =>
                      dt.id === "name" ||
                      dt.id === "total" ||
                      dt.id === "recieved" ||
                      dt.id === "recieveable"
                  ),
                ]}
              />
            )
          )}
          {Customers.data && activeTab === 1 && (
            <SearchableTable
              //   setOpenEditModal={setOpenEditModal}
              //   setOpenDeleteModal={setOpenDeleteModal}
              //   setSelected={setSelected}
              SearchPlaceholder={"Search Company Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              // CurrentData={Suppliers.data}
              CurrentData={Suppliers.data}
              Columns={[
                {
                  id: "payments",
                  title: "Payments",
                  type: "Company",
                },
                ...SupplierColumns.filter(
                  (dt) =>
                    dt.id === "name" ||
                    dt.id === "total" ||
                    dt.id === "paid" ||
                    dt.id === "payable"
                ),
              ]}
            />
          )}
        </div>
        {OpenModal && (
          <AddPaymentModal Open={OpenModal} setOpen={setOpenModal} />
        )}
      </div>
    </div>
  );
};

export default Payment;
